module.exports = new __parcel__URL__("oco2geos-co2-daygrid-v10r.thumbnails.daily.bd801c54.png").toString();